<template>
  <div class="jibenxinxi">
    <figure @click="getindex(0) " v-if="userInfo.userRole!=3&&userInfo.userRole!=2">
      <img src="../assets/gerenzhongxin/geren15.png">
      <figcaption>基本资料</figcaption>
    </figure>
    <figure @click="getindex(1) " v-if="userInfo.userRole!=3&&userInfo.userRole!=2">
      <img src="../assets/gerenzhongxin/geren14.png">
      <figcaption>我的分数</figcaption>
    </figure>
    <figure @click="getindex(6) " v-if="userInfo.userRole==3||userInfo.userRole==2">
      <img src="../assets/gerenzhongxin/geren14.png">
      <figcaption>我的学生</figcaption>
    </figure>
    <figure @click="getindex(2) ">
      <img src="../assets/gerenzhongxin/geren9.png">
      <figcaption>收藏院校</figcaption>
      <div class="xiaoxi" v-show="college != 0">
        {{college}}
      </div>
    </figure>
    <figure @click="getindex(3) ">
      <img src="../assets/gerenzhongxin/geren8.png">
      <figcaption>收藏专业</figcaption>
      <div class="xiaoxi" v-show="major != 0">
        {{major}}
      </div>
    </figure>
    <figure @click="getindex(4) ">
      <img src="../assets/gerenzhongxin/geren12.png">
      <figcaption>我的关注</figcaption>
      <div class="xiaoxi" v-show="zhu != 0">
        {{zhu}}
      </div>
    </figure>
    <figure @click="getindex(7) ">
      <img src="../assets/gerenzhongxin/geren11.png">
      <figcaption>职业测评</figcaption>
    </figure>
    <figure @click="getindex(8) ">
      <img src="../assets/gerenzhongxin/geren10.png">
      <figcaption>分数位次</figcaption>
    </figure>
    <figure @click="getindex(5) ">
      <img src="../assets/gerenzhongxin/geren7.png">
      <figcaption>志愿报告单</figcaption>
      <div class="xiaoxi" v-show="zyd != 0&&zyd != null">
        {{zyd}}
      </div>
    </figure>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userInfo: this.$utils.getlocalStorage('userInfo'),
        major: 0,
        college: 0,
        zyd: 0,
        zhu: 0
      }
    },
    methods: {
      getindex(index) {
        if (this.$utils.tologin(this)) {
          if (index == 0) {
            this.$router.push('/gerenzhongxin')
          } else if (index == 1) {
            if (this.$utils.getUserInfo(this)) {
              this.$router.push('/grzx_wdfs')
            }
          } else if (index == 2) {
            this.$router.push('/grzx_shouchangxueyuan')
          } else if (index == 3) {
            this.$router.push('/grzx_chouchangzhuanye')
          } else if (index == 4) {
            this.$router.push('/grzx_wodeguanzhu')
          } else if (index == 5) {
            this.$utils.removelocalStorage("zyd_selectId")
            this.$router.push('/grzx_wodezhiyuan')
          } else if (index == 6) {
            this.$router.push('/grzx_wdxs')
          } else if (index == 7) {
            this.$router.push('/grzx_xinggeceping')
          } else if (index == 8) {
            this.$router.push('/grzx_scorerank')
          }
        }

      },
    },
    created() {
      let userCang = this.$utils.getlocalStorage('userCang')
      let userInfo = this.$utils.getlocalStorage('userInfo')
      if (userInfo != null && userCang != null) {
        if (userInfo.userRole != '3' && userInfo.userRole != '2') {
          this.college = userCang.college.length;
          this.major = userCang.major.length;
          this.zhu = userCang.collegescore.length + userCang.majorscore.length
          this.zyd = this.$utils.getlocalStorage('zydNum');
        }

      }
    }


  }
</script>

<style>
  .jibenxinxi {
    width: 210px;
    min-height: 580px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 15px 0;
    padding-right: 0px;
    box-sizing: border-box;
  }

  .jibenxinxi figure {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .jibenxinxi figure img {
    height: 44px;
    margin-left: 22px;
  }

  .jibenxinxi figure figcaption {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    margin-left: 10px;
  }

  .xiaoxi {
    margin-left: 10px;
    background: url(../assets/gerenzhongxin/geren18.png)no-repeat;
    background-size: 100% 100%;
    width: 33px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/jibenxinxi.vue